export const newProduct = {
  attributes: {
    name: '',
    selling_price: '',
    warranty: '',
    description: '',
    unity_type: '',
    unit_quantity: '',
    bar_code: '',
    original_code: '',
    custom_search_parameter: '',
    net_profit: '',
    product_category_id: null,
    product_group_id: null,
    manufacturer_id: null,
    tax_attributes: {},
    tax_classifications: {},
    product_stock_attributes: {
      stock_quantity: '',
      storage_drawer: '',
      storage_shelf: '',
      minimum_quantity: '',
    },
  },
}
